import script from "./GmxButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxButton.vue?vue&type=script&setup=true&lang=js"

import "./GmxButton.vue?vue&type=style&index=0&id=67a300bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a300bb"]])

export default __exports__